import React, { Component } from "react";
import { HashRouter,BrowserRouter, Route, Redirect, Switch } from "react-router-dom";
import "./App.scss";
import {UserConfirmation} from "./views/Admin/UploadContent/CustomPrompt";

import ProtectedRoute from "./components/common/protectedRoute";

const loading = () => (
  <div className="animated fadeIn pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const DefaultLayout = React.lazy(() => import("./containers/DefaultLayout"));
// Containers

// Pages
const Login = React.lazy(() => import("./views/Account/Login/Login"));
const ForgotPassword = React.lazy(() =>
  import("./views/Account/ForgotPassword/ForgotPassword")
);
const ConfirmAccount = React.lazy(() =>
  import("./views/Account/ConfirmAccount/ConfirmAccount")
);
const SetPassword = React.lazy(() =>
  import("./views/Account/SetPassword/SetPassword")
);

const Page400 = React.lazy(() => import("./views/common/Page400"));
const Page403 = React.lazy(() => import("./views/common/Page403"));
const Page404 = React.lazy(() => import("./views/common/Page404"));
const Page500 = React.lazy(() => import("./views/common/Page500"));
// Pages

class App extends Component {
  state = {};

  componentDidMount() { }

  render() {
    return (
      <HashRouter
      getUserConfirmation={(message, callback) =>  
      UserConfirmation(message, callback)}>
        <React.Suspense fallback={loading()}>

          <Switch>
            <Route
              exact
              path="/account/login"
              name="Login"
              render={props => <Login {...props} />}
            />

            <Route
              exact
              path="/account/forgotpassword/:email?"
              name="Forgot Password"
              render={props => <ForgotPassword {...props} />}
            />

            <Route
              exact
              path="/account/confirmation/:u?/:token?"
              name="Account Confirmation"
              render={props => <ConfirmAccount {...props} />}
            />

            <Route
              exact
              path="/account/setpassword/:u?/:token?"
              name="Set Password"
              render={props => <SetPassword {...props} />}
            />

            <Route
              exact
              path="/400"
              name="Page 400"
              render={props => <Page400 {...props} />}
            />

            <Route
              exact
              path="/403"
              name="Page 403"
              render={props => <Page403 {...props} />}
            />

            <Route
              exact
              path="/404"
              name="Page 404"
              render={props => <Page404 {...props} />}
            />

            <Route
              exact
              path="/500"
              name="Page 500"
              render={props => <Page500 {...props} />}
            />

            <ProtectedRoute
              path="/admin"
              name="Admin"
              render={props => <DefaultLayout {...props} />}
            />
            
            <ProtectedRoute
              path="/"
              name="Home"
              render={props => <DefaultLayout {...props} />}
            />

            <Redirect from="/" to="/account/login" />
          </Switch>
        </React.Suspense>
      </HashRouter>
    );
  }
}

export default App;
